import { render, staticRenderFns } from "./UpdateEmotionDialog.vue?vue&type=template&id=85bca5ba&scoped=true"
import script from "./UpdateEmotionDialog.vue?vue&type=script&lang=js"
export * from "./UpdateEmotionDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateEmotionDialog.vue?vue&type=style&index=0&id=85bca5ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bca5ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85bca5ba')) {
      api.createRecord('85bca5ba', component.options)
    } else {
      api.reload('85bca5ba', component.options)
    }
    module.hot.accept("./UpdateEmotionDialog.vue?vue&type=template&id=85bca5ba&scoped=true", function () {
      api.rerender('85bca5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/chat/emotion/dialog/UpdateEmotionDialog.vue"
export default component.exports